import { FC } from 'react';

import './EmbeddedViewer.scss';

interface IProps {
  data?: IEmbedded;
}

const EmbeddedViewer: FC<IProps> = ({ data }) => {
  return (
    <div
      className="EmbeddedViewer mx-1 mx-sm-3 mx-md-5 mx-lg-7"
      dangerouslySetInnerHTML={{ __html: data?.html || '' }}
    />
  );
};

export default EmbeddedViewer;
